<template>
  <svg aria-hidden="true" fill="none" viewBox="0 0 24 24" ...attributes>
    <path
      stroke="#596A73"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M4.75 5.75H19.25"
    ></path>
    <path
      stroke="#596A73"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M4.75 18.25H19.25"
    ></path>
    <path stroke="#596A73" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.75 12H19.25"></path>
  </svg>
</template>
